module.exports = __webpack_public_path__ + "img/256x256_hexagon_warp_gate.af9cdf95.svg";